module.exports = __webpack_public_path__ + "static/media/stepper-complete-icon.f8ea16ff.svg";